import { AxiosError } from 'axios';
import { IFileResponse } from '../models/core.models';

export class SharedService {

	public showFileDialog(
		multiple: boolean = false,
		acceptedFilesTypes: string | null = null,
		callback: (res: FileList, err?: any) => Promise<void>
	) {
		const input = document.createElement('input');
		input.type = 'file';
		input.accept = acceptedFilesTypes ?? '';
		input.style.display = 'none';
		input.multiple = multiple;
		input.click();
		input.onchange = () => {
			callback(input!.files!);
		};
	}

	/**
	 * parse content disposition
	 * @param content
	 */
	public parseContentDisposition(disposition: string): string {
		const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
		const matches = filenameRegex.exec(disposition);
		if (matches != null && matches[1]) {
			return matches[1].replace(/['"]/g, '');
		}
		return 'File';
	}

	public downloadFile(file?: IFileResponse) {
		if (!file) return;

		const link = document.createElement('a');
		link.target = '_blank';
		link.download = file!.fileDownloadName;
		link.href = window.URL.createObjectURL(file!.fileContents);
		link.click();
	}
	
	public parseAxiosError = (error: AxiosError): string => {
		if (error.response) {
			if (error.response.data && Object.keys(error.response.data).length) {
				let errorMessage = error.response?.data?.message;
				if (!errorMessage && error.response?.data?.errors) {
					errorMessage = Object.values<string>(error.response?.data?.errors).reduce((x, y) => x.concat(y));
				}

				return errorMessage;
			}
			return error.response.statusText;
		}

		return error.message;
	}

	/**
	* Parse the provided string return Integer
	* @param: id String to Parse
	*/
	public static parseInt(id: any) {
		const res = id ? parseInt(id.toString(), 10) : (null as any);
		return res;
	}
	
	/**
	* Convert enum to object of type { name: string; value: string }[]
	* @param enumVar Enum
	*/
	public static enumToObjectArray(enumVar: any): { name: string; value: string }[] {
		const objectArray: { name: string; value: string }[] = [];

		for (const n in enumVar) {
			if (enumVar.hasOwnProperty(n) && isNaN(this.parseInt(n))) {
				objectArray.push({
					name: n,
					value: enumVar[n] as string,
				});
			}
		}
		return objectArray;
	}
	
	public static nameof = <T>(propertyName: keyof T) => propertyName;

	public static getGuid(): string {
		return (([1e7] as any) + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: any) =>
			(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
		);
	}
}
